<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="move-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="section">
                        <span v-if="section.is_chapter">章</span>
                        <span v-else>本文</span>
                        <strong>
                            {{section.section_name}}
                        </strong>
                        の移動
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group" v-if="section">
                        <div class="small">移動先を選択してください。</div>
                        <div class="list-group">
                            <button type="button"
                                class="list-group-item list-group-item-action"
                                :class="{
                                    'selected': s.id == section.id,
                                    'list-group-item-dark': s.is_chapter == 1
                                }"
                                @click.prevent="move(s.id)"
                                :id="'sort-' + s.id"
                                v-for="(s, i) in sections" :key="s.id">
                                <i class="fas fa-check" v-if="section.id === s.id"></i>
                                <i class="fas fa-sort-up" v-else-if="selectedIndex > i"></i>
                                <i class="fas fa-sort-down" v-else-if="selectedIndex < i"></i>
                                {{s.section_name}}
                                <span v-if="section.id === s.id" class="small">
                                    移動をキャンセル
                                </span>
                                <span v-else-if="selectedIndex > i" class="small">
                                    の前に移動
                                </span>
                                <span v-else class="small">
                                    の後に移動
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.section {
    font-size: 1.1rem;
}
.selected {
    background-color: #3490dc !important;
    color: white;
    &:hover {
        background-color: #3490dc !important;
        color: white;
    }
}
</style>

<script>
export default {
    props: {
        section: {
            default: null,
        },
        sections: {
            default: [],
        },
    },
    methods: {
        move(to_id = null) {
            if (to_id !== this.section.id) {
                this.$emit("moveTo", to_id);
            }
            $("#move-modal").modal("hide");
        },
    },
    computed: {
        selectedIndex() {
            return _.findIndex(this.sections, {id: this.section.id});
        }
    },
    mounted() {
        $("#move-modal").on("shown.bs.modal", (e) => {
            const button_top = $("#sort-" + this.section.id)[0].offsetTop;
            const parent_top = $("#sort-" + this.section.id)[0].offsetParent.offsetTop;
            $("#move-modal").animate({scrollTop: button_top + parent_top});
        });
        $("#move-modal").on("hide.bs.modal", (e) => {
            this.$emit("closed");
        });
    }
}
</script>